<template>
<div class="wrapper">
    <modal :no-footer="true" size="large" @close="$emit('close')">
        <template slot="header">
            {{ facility.facility_number }}
        </template>

        <template slot="content">
            <form :disabled="is_loading" @submit.prevent="onSaveFacility">
                <div class="mt-2 mb-4">
                    <p>If letters have been sent for this facility, set the date they were dropped off below!</p>
                </div>

                <div class="flex jc-sb">
                    <div class="flex-33 mr-3">
                        <label for="edit-initial-letter-date">Initial Letter Date</label>
                        <datepicker :typeable="true" v-model="updated_facility.initial_letter_sent_date" :format="'yyyy-MM-dd'"></datepicker>
                    </div>

                    <div class="flex-33 ml-3 mr-3">
                        <label for="edit-reminder-letter-date">Reminder Letter Date</label>
                        <datepicker :typeable="true" v-model="updated_facility.reminder_letter_sent_date" :format="'yyyy-MM-dd'"></datepicker>
                    </div>

                    <div class="flex-33 ml-3">
                        <label for="edit-welcome-letter-date">Welcome Letter Date</label>
                        <datepicker :typeable="true" v-model="updated_facility.welcome_letter_sent_date" :format="'yyyy-MM-dd'"></datepicker>
                    </div>
                </div>

                <div class="flex jc-fe mt-5">
                    <div v-show="is_loading" class="flex ai-c mr-2">
                        <img src="../assets/img/loading-black-32.gif" alt="loading" />
                    </div>

                    <button :disabled="is_loading" type="submit">Save</button>
                </div>
            </form>
        </template>
    </modal>
</div>
</template>

<script>
import http from "@/http"
import { objectToParams } from "@/utilities/form-data"

export default {
    name: "mark-letters-sent-modal",

    props: ["facility"],

    data () {
        return {
            is_loading: false,
            updated_facility: {
                initial_letter_sent_date: this.facility.initial_letter_sent_date,
                reminder_letter_sent_date: this.facility.reminder_letter_sent_date,
                welcome_letter_sent_date: this.facility.welcome_letter_sent_date
            }
        }
    },

    created () {
        this.normalizeLetterDates()
    },

    methods: {
        /**
         * Normalize the letter send dates because JavaScript automatically subtracts hours
         * for local time, making it appear as if the date selected is the day before.
         */
        normalizeLetterDates () {
            if (this.updated_facility.initial_letter_sent_date) {
                const date = new Date(this.updated_facility.initial_letter_sent_date)
                date.setUTCHours(date.getHours())
                this.updated_facility.initial_letter_sent_date = date
            }

            if (this.updated_facility.reminder_letter_sent_date) {
                const date = new Date(this.updated_facility.reminder_letter_sent_date)
                date.setUTCHours(date.getHours())
                this.updated_facility.reminder_letter_sent_date = date
            }

            if (this.updated_facility.welcome_letter_sent_date) {
                const date = new Date(this.updated_facility.welcome_letter_sent_date)
                date.setUTCHours(date.getHours())
                this.updated_facility.welcome_letter_sent_date = date
            }
        },

        async onSaveFacility () {
            const params = objectToParams(this.updated_facility)

            this.is_loading = true

            try {
                await http.post(`/api/facilities/${this.facility.id}`, params)

                this.$emit("save")
            } catch (ex) {
                console.log(ex)
            } finally {
                this.is_loading = false
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/MarkLettersSentModal.vue